import React, { useEffect, useState } from "react";
import { Table, Button, Typography, Image, Popconfirm, Space } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import deleteDataById from "../../../hooks/admin/deleteDataById";
import { Helmet } from "react-helmet-async";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const GeneralServices = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("admin"));

  useEffect(() => {
    const fetchServices = async () => {
      setLoading(true);
      try {
        const baseUrl = process.env.REACT_APP_APIURL;
        const res = await fetch(`${baseUrl}/admin/getallservice`, {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });
        const response = await res.json();
        if (response.status_code === 200) {
          setServices(response.data);
        }
      } catch (err) {
        toast.error(t("Fetch failed"));
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const handleEdit = (id) => {
    navigate(`/admin/settings/general_services/${id}`);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    const response = await deleteDataById("admin/deleteservice", id);
    if (response?.status_code === 200) {
      setServices(services.filter((item) => item.id !== id));
      toast.success(t("Deleted successfully"));
    } else {
      toast.error(response?.message || response?.err || t("Delete failed"));
    }
    setLoading(false);
  };

  const columns = [
    {
      title: t("Image"),
      dataIndex: "image",
      key: "image",
      render: (image) => <Image width={60} src={image} alt="service" />,
    },
    {
      title: t("Title"),
      dataIndex: "title",
      key: "title",
    },
    {
      title: t("Description"),
      dataIndex: "description",
      key: "description",
    },
    {
      title: t("Options"),
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="default"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.id)}
          />
          <Popconfirm
            title={t("delete_alert_title")}
            description={t("delete_alert_des")}
            onConfirm={() => handleDelete(record.id)}
            okText={t("yes")}
            cancelText={t("no")}
           okButtonProps={{
                style: { backgroundColor: "#f4900c", borderColor: "#f4900c", color: "white" }
            }}
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Helmet>
        <title>{`${t("Admin")} - ${t("All_Service")}`}</title>
      </Helmet>

      <div className="flex justify-between items-center mb-4">
        <Title level={4} className="!mb-0">{t("All_Service")}</Title>
        <Link to="/admin/settings/general_services/add">
          <button className="btn btn-primary btn-sm text-white" icon={<PlusOutlined />}>
            <span className="mr-2"><PlusOutlined /></span>   {t("Add_Service")}
          </button>
        </Link>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Table
          dataSource={services}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 10 }}
          scroll={{ x: true }}
        />
      )}
    </div>
  );
};

export default GeneralServices;

